<script>
import Constants from '../constants';
import vueInstagram from '@/components/vueInstagram';
import youtubeContainer from '@/components/youtubeContainer';
import niconicoContainer from '@/components/niconicoContainer';
import soundPlayer from '@/components/soundPlayer';
import vueBandCamp from '@/components/vueBandCamp';

export default {
  name: 'album14',
  components: {
    vueInstagram,
    youtubeContainer,
    niconicoContainer,
    soundPlayer,
    vueBandCamp
  },
  data() {
    return {
      ready: false,
      instagramPosts: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.instagramPosts = [
        ...Constants.INSTAGRAM_POSTS.ALBUM14_6,
      ];
      this.ready = true;
    }
  },
};
</script>

<template>
  <div class="uncommon-container" v-if="ready" :class="$mq">

    <div class="contents-container">
      <div class="title">{{$t('message.shop.bandcamp')}}</div>
      <div class="contents-bandcamp">
        <vue-band-camp
          embedded-url="https://bandcamp.com/EmbeddedPlayer/album=2941115533/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/"
          href-url="https://kyousou-gakudan.bandcamp.com/album/chronicle-of-faith"
          :album-title="$t('message.discography.albums.a14.name')"
          />
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'cZVIGwANlsI'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'aLeE4xplNsw'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'Zo6xXXGImCw'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'F_08FBdOB9Q'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <niconico-container :file-url="'sm39818229'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'vhJJ2ujN8Vk'"/>
      </div>
    </div>
    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'W-WeKLxXAr4'"/>
      </div>
    </div>
    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'c5dMx9maBb4'"/>
      </div>
    </div>
    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'WWo-iX8Wi7k'"/>
      </div>
    </div>

    <div class="contents-container" v-for="post in instagramPosts" :key="post">
      <div class="contents-instagram">
        <vue-instagram :posts="[post]" :show-follow-btn="false"/>
      </div>
    </div>


    <div class="contents-container">
      <div class="banners-container">
        <div class="title">{{$t('message.discography.specialThanks')}}</div>
        <a class="banner200x40" target="_blank" :title="'白夜の語り部'"
          href="http://studio-lepus.com/"
        >
          <img src="../assets/img/banner/circle/studio-lepus.gif">
        </a>
        <div class="small">{{$t('message.common.jacket')}} 三滝航</div>

        <a class="banner200x40" target="_blank" :title="'@sakaeda_amfgc'"
          href="https://twitter.com/sakaeda_amfgc"
        >
          <img src="../assets/img/sns/twitter.svg">
        </a>
        <div class="small">{{$t('message.discography.movie')}} 酒枝 裕</div>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'X0pu_Q6FPw8'"/>
      </div>
    </div>
    

  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @import "../css/albumUncommon";
</style>
